import { apiBaseURL } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { fetchMandatesInvitationData } from './fetch-mandates-invitation-data';

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  apiBaseURL: '/api',
}));

describe('unit | API | queries | fetch-mandates-invitation-data', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const invitationLinkId = 'invitation-link-123';
  const URL = `${apiBaseURL}/v1/direct_debit_collection_invitation_links/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe(fetchMandatesInvitationData, () => {
    it('fetches invitation data successfully', async () => {
      const apiResponse = {
        invitationLinkId,
        organizationName: 'Test Organization',
        organizationLogoUrl: 'https://example.com/logo.png',
        organizationCountry: 'FR',
      };

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchMandatesInvitationData({ invitationLinkId });

      expect(mockQontoClient).toHaveBeenCalledWith(`${URL}/${invitationLinkId}`);
      expect(result).toStrictEqual({
        invitationLinkId,
        organizationName: 'Test Organization',
        organizationLogoUrl: 'https://example.com/logo.png',
        organizationCountry: 'FR',
      });
    });
  });
});
